import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const NotificationIcon = observer(
    'NotificationIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                stroke='#E4E4E7'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M12.017 24.5a2.262 2.262 0 0 0 3.966 0M7 9.333a7 7 0 0 1 14 0c0 8.167 3.5 10.5 3.5 10.5h-21S7 17.5 7 9.333Z'
            />
        </SvgElement>
    )
);
